import { render, staticRenderFns } from "./PendingGroupRenewalTable.vue?vue&type=template&id=925c67ea&scoped=true&"
import script from "./PendingGroupRenewalTable.vue?vue&type=script&lang=js&"
export * from "./PendingGroupRenewalTable.vue?vue&type=script&lang=js&"
import style0 from "./PendingGroupRenewalTable.vue?vue&type=style&index=0&id=925c67ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925c67ea",
  null
  
)

export default component.exports